import createVueApp from '@/common/createApp'
import sidebar from '@/config/sidebars/mlap'

Styxie.Initializers.MlapSettingsIntegrations = {
  index: async(props) => {
    const { default: SettingsIntegrations } = await import('@/vue_widgets/mlap/settings/integrations/index.vue')
    createVueApp(SettingsIntegrations, { props, sidebar })
  }
}
